const SUCCESS = 200;
const REDIRECTION = 300;

const isSuccessResponse = ({ status }: { status: number }) => status >= SUCCESS && status < REDIRECTION;

export default isSuccessResponse;
